
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prix-immobilier-maroc",
      function () {
        return require("private-next-pages/prix-immobilier-maroc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prix-immobilier-maroc"])
      });
    }
  